import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import LacquersDms from '../../../../components/editable-cell/form-items/lacquers-dms'
import { hasDmsInFinishing } from '../../../../helpers/is-dms-machine'
import { DataSourceItem } from '../../helpers/convert-calculations-to-data-source'
import { isColorProofDurstRollout } from '../../helpers/color-proof-branch'
import isCalculation from '../../helpers/is-calculation'
import { validateLacquersDmsColumn } from '../../helpers/validators'
import type { CalculationColumn } from '../../types/column-types'

export const lacquersDmsColumn: CalculationColumn = {
    dataIndex: 'lacquersDms',
    title: <RotatedTitle>Лак DMS</RotatedTitle>,
    width: 30,
    editable: true,
    FormItem: <LacquersDms />,
    validator: validateLacquersDmsColumn,
    onCell: (record: DataSourceItem) => {
        if (isCalculation(record)) {
            return { colSpan: 0 }
        }
        return {
            colSpan: 1,
            editable:
                hasDmsInFinishing(record.additional_machines) &&
                !isColorProofDurstRollout(record),
        }
    },
}
